import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { isProductionHost } from 'lib/env'
import { urlWithLangParam } from 'lib/helpers'

import { AppHeaderContext } from 'components/AppHeader/AppHeader'
import Link from 'components/Link'
import Badge from 'components/UI/Badge/Badge'

import './app-header-inbox-nav.pcss'

const AppHeaderInboxNav = () => {
    const { t, i18n } = useTranslation(['common'])
    const env = isProductionHost() ? 'production' : 'development'

    const { unreadMessageCount } = useContext(AppHeaderContext)
    const url = t(`common:inbox.url.${env}`)

    return (
        <Link
            to={urlWithLangParam(url, i18n.language)}
            title={t('common:inbox.title')}
            trackName="inbox"
            target="_self"
            external
            className="app-header-inbox-nav"
        >
            <Badge count={unreadMessageCount}>
                {t('common:inbox.title')}
            </Badge>
        </Link>
    )
}

export default AppHeaderInboxNav
